import hh from "../../assets/images/Logo Hospi Housing.webp";
import { theme } from "styles/theme";

export enum MapIcons {
  HospiIcon = "HospiIcon",
  Pin = "Pin",
  PinSelected = "PinSelected",
  PinSelectedActive = "PinSelectedActive",
  Cluster = "Cluster",
  ClusterSelected = "ClusterSelected",
  ClusterSelectedActive = "ClusterSelectedActive"
}

const iconsCache: { [key: string]: any } = {};

export interface IMapSymbol extends google.maps.Symbol {
  labelColor?: string;
}
export interface IMapIcon extends google.maps.Icon {
  labelColor?: string;
}

export const getMapIcon = (
  name: MapIcons
): IMapIcon | IMapSymbol | undefined => {
  switch (name) {
    case MapIcons.HospiIcon:
      if (!iconsCache[MapIcons.HospiIcon]) {
        iconsCache[MapIcons.HospiIcon] = {
          url: hh,
          size: new google.maps.Size(158, 94),
          scaledSize: new google.maps.Size(158 / 2, 94 / 2),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(158 / 2 / 2, 94 / 2 / 2)
        };
      }
      return iconsCache[MapIcons.HospiIcon];
    case MapIcons.Pin:
      if (!iconsCache[MapIcons.Pin]) {
        iconsCache[MapIcons.Pin] = {
          path: "M 0, 16 a 16,16 0 1,1 32,0 a 16,16 0 1,1 -32,0",
          fillColor: theme.colors.text,
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 1,
          anchor: new google.maps.Point(16, 16),
          labelOrigin: new google.maps.Point(16, 16),
          labelColor: "white"
        };
      }
      return iconsCache[MapIcons.Pin];
    case MapIcons.PinSelected:
      if (!iconsCache[MapIcons.PinSelected]) {
        iconsCache[MapIcons.PinSelected] = {
          path: "M 0, 16 a 16,16 0 1,1 32,0 a 16,16 0 1,1 -32,0",
          fillColor: theme.colors.bgSecondary,
          fillOpacity: 1,
          strokeWeight: 2,
          strokeColor: theme.colors.text,
          rotation: 0,
          scale: 1,
          anchor: new google.maps.Point(16, 16),
          labelOrigin: new google.maps.Point(16, 16),
          labelColor: theme.colors.text
        };
      }
      return iconsCache[MapIcons.PinSelected];
    case MapIcons.PinSelectedActive:
      if (!iconsCache[MapIcons.PinSelectedActive]) {
        iconsCache[MapIcons.PinSelectedActive] = {
          path: "M 0, 16 a 16,16 0 1,1 32,0 a 16,16 0 1,1 -32,0",
          fillColor: theme.colors.bgSecondary,
          fillOpacity: 1,
          strokeWeight: 5,
          strokeColor: "black",
          rotation: 0,
          scale: 1,
          anchor: new google.maps.Point(16, 16),
          labelOrigin: new google.maps.Point(16, 16),
          labelColor: theme.colors.text
        };
      }
      return iconsCache[MapIcons.PinSelectedActive];
    case MapIcons.Cluster:
      if (!iconsCache[MapIcons.Cluster]) {
        iconsCache[MapIcons.Cluster] = {
          path: "M 0, 16 a 16,16 0 1,1 32,0 a 16,16 0 1,1 -32,0",
          fillColor: theme.colors.thirdly,
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 1,
          anchor: new google.maps.Point(16, 16),
          labelOrigin: new google.maps.Point(16, 16),
          labelColor: "white"
        };
      }
      return iconsCache[MapIcons.Cluster];
    case MapIcons.ClusterSelected:
      if (!iconsCache[MapIcons.ClusterSelected]) {
        iconsCache[MapIcons.ClusterSelected] = {
          path: "M 0, 16 a 16,16 0 1,1 32,0 a 16,16 0 1,1 -32,0",
          fillColor: theme.colors.thirdly,
          fillOpacity: 1,
          strokeWeight: 3,
          strokeColor: "blue",
          rotation: 0,
          scale: 1,
          anchor: new google.maps.Point(16, 16),
          labelOrigin: new google.maps.Point(16, 16),
          labelColor: "white"
        };
      }
      return iconsCache[MapIcons.ClusterSelected];
    case MapIcons.ClusterSelectedActive:
      if (!iconsCache[MapIcons.ClusterSelectedActive]) {
        iconsCache[MapIcons.ClusterSelectedActive] = {
          path: "M 0, 16 a 16,16 0 1,1 32,0 a 16,16 0 1,1 -32,0",
          fillColor: theme.colors.primary,
          fillOpacity: 1,
          strokeWeight: 5,
          strokeColor: "black",
          rotation: 0,
          scale: 1,
          anchor: new google.maps.Point(16, 16),
          labelOrigin: new google.maps.Point(16, 16),
          labelColor: "white"
        };
      }
      return iconsCache[MapIcons.ClusterSelectedActive];
    default:
      return undefined;
  }
};
